const data= {
  Response: [
    {
      Fecha: 'string',
      TasaCumplimiento: 0,
      VerifactuDesgloseGeneral: {
        Correctas: 0,
        Incorrectas: 0,
        Pendientes: 0
      },
      VerifactuDesgloseTipo: [
        {
          Tipo: 0,
          Correctas: 0,
          Incorrectas: 0,
          Pendientes: 0
        }
      ]
    }
  ],
  AlertasVerifactu: [
    {
      Titulo: 'string',
      Detalle: 'string'
    }
  ],
  blnError: false,
  codError: 'string',
  msgError: 'string'
}

export default data
